import React from "react";


export default function UploadUnico({ label, id, feedbackText, status, setUploadError, fieldErrors, isRequired, arquivo, setArquivo }) {

    const handleFileChange = (event) => {
        let arr = arquivo?[...arquivo]:[]
        arr.push({
            id: id,
            arquivo: event.target.files
        });
        setArquivo(arr);
    };

    function getNomeArquivo(){
        if( arquivo ){
            const item = arquivo.find( a => a.id === id);
            
            return item?item.arquivo[0].name:'';
        }
        return '';
    }

    function temArquivo(){
        if( arquivo ){
            const item = arquivo.find( a => a.id === id);            
            return item;
        }
        return false;
    }

    function montaErro(){
        if( fieldErrors){
            const item = fieldErrors.find( e => e.id === id);            
            if( item ){
                return (
                    <span className="feedback danger mt-1" role="alert">
                        <i className="fas fa-times-circle" ></i> {item.errorMessage}
                    </span>
                )
            }
        }
        return (<div/>)
    }

    function removerArquivo() {
        if (arquivo) {
            const novoArquivo = arquivo.filter(a => a.id !== id);
            setArquivo(novoArquivo); 
        }
    }

    if( temArquivo()){
        return (
            <div className="br-upload mt-4">
                <label className="upload-label" htmlFor={id} style={{marginBottom: '10px'}}>
                    <span style={{ position: "relative", top: "-5px", left: "3px" }}>
                        {label}
                    </span>
                </label>
                <div
                className="br-drag d-flex align-items-center"
                style={{
                    border: "2px dashed #1351b4",
                    padding: "20px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    backgroundColor: "#f8f9fa",
                    textAlign: "center",
                }}
                onClick={() => removerArquivo()}
                onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.currentTarget.style.borderColor = "#0056b3";
                }}
                onDragLeave={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.currentTarget.style.borderColor = "#1351b4";
                }}
                onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const droppedFiles = Array.from(e.dataTransfer.files);
                    handleFileChange({ target: { files: droppedFiles } });
                    e.currentTarget.style.borderColor = "#1351b4";
                }}
            >
                <i className="fas fa-trash" style={{ fontSize: "20px", color: "#1351b4", marginRight: 10 }}></i>
                <p style={{ margin: 0, color: '#1351b4' }}>{getNomeArquivo()}</p>
            </div>
            </div>
        )
    }

    return (
        <div className="br-upload mt-4">
            <label className="upload-label" htmlFor={id}>
                <span>{label}</span>
            </label>
            <input
                className="upload-input"
                id={id}
                type="file"
                onChange={handleFileChange}                
                style={{ display: "none" }}
            />
            <div
                className="br-drag d-flex align-items-center"
                style={{
                    border: "2px dashed #1351b4",
                    padding: "20px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    backgroundColor: "#f8f9fa",
                    textAlign: "center",
                }}
                onClick={() => document.getElementById(id).click()}
                onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.currentTarget.style.borderColor = "#0056b3";
                }}
                onDragLeave={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.currentTarget.style.borderColor = "#1351b4";
                }}
                onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const droppedFiles = Array.from(e.dataTransfer.files);
                    handleFileChange({ target: { files: droppedFiles } });
                    e.currentTarget.style.borderColor = "#1351b4";
                }}
            >
                <i className="fas fa-upload" style={{ fontSize: "20px", color: "#1351b4", marginRight: 10 }}></i>
                <p style={{ margin: 0, color: '#1351b4' }}>Selecione ou arraste um arquivo</p>
                
            </div>
            {montaErro() }
            {status === "danger" && isRequired && (
                <span className="feedback danger mt-1" role="alert">
                    <i className="fas fa-times-circle" ></i> {feedbackText}
                </span>
            )}
        </div>
    );
}
